// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { Suspense, useEffect } from 'react'
// import { HashRouter, Route, Routes } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'
// import { fetchUserLogin } from './admin/redux/auth/slice'
// import { fetchUser } from './main/redux/auth/slice'
// import { fetchPharmacyUserLogin } from './pharmacy/redux/auth/slice'
// // import { fetchPharmacyUser } from './main/redux/auth/slice'
// import { fetchLaboratoryUserLogin } from './laboratory/redux/auth/slice'
// import '../src/index.css'
// import { persistVisitType } from './admin/redux/settings/slice'
// import { API } from './admin/services'
// import { getAppointmentStatus, getSlotType } from './admin/redux/providerManagement/slice'

// // Pages
// const AdminLogin = React.lazy(() => import('./admin/views/pages/login/Login'))
// const PharmacyLogin = React.lazy(() => import('./pharmacy/views/pages/login/Login'))
// const LaboratoryLogin = React.lazy(() => import('./laboratory//views/pages/login/Login'))
// const TermsAndCondition = React.lazy(() =>
//   import('./global/views/pages/termsCondition/TermsCondition'),
// )
// const PrivacyAndPolicy = React.lazy(() =>
//   import('./global/views/pages/privacyPolicy/PrivacyPolicy'),
// )

// const Admin = React.lazy(() => import('./admin'))
// const Main = React.lazy(() => import('./main'))
// const Pharmacy = React.lazy(() => import('./pharmacy'))
// const Laboratory = React.lazy(() => import('./laboratory'))

// const loading = (
//   <div className="pt-3 text-center">
//     <div className="sk-spinner sk-spinner-pulse"></div>
//   </div>
// )

// const App = () => {
//   const dispatch = useDispatch()
//   const { adminAuth } = useSelector((state) => state.adminAuthReducer)
//   const { adminPharmacyAuth } = useSelector((state) => state.pharmacyAuthReducer)
//   const { adminLaboratoryAuth } = useSelector((state) => state.laboratoryAuthReducer)

//   useEffect(() => {
//     dispatch(fetchUserLogin())
//     dispatch(fetchUser())
//     dispatch(persistVisitType())
//     dispatch(getAppointmentStatus())
//     dispatch(fetchLaboratoryUserLogin())
//     // dispatch(userPharmacyLogin())
//     dispatch(fetchPharmacyUserLogin())
//     dispatch(getSlotType())
//   }, [])

//   return (
//     <HashRouter>
//       <Suspense fallback={loading}>
//         <Routes>
//           {adminAuth === false ? (
//             <Route exact path="/admin/*" name="Admin Login" element={<AdminLogin />} />
//           ) : (
//             <Route exact path="/admin/*" name="Home" element={<Admin />} />
//           )}
//           {adminPharmacyAuth === false ? (
//             <Route exact path="/pharmacy/*" name="Admin Login" element={<PharmacyLogin />} />
//           ) : (
//             <Route exact path="/pharmacy/*" name="Home" element={<Pharmacy />} />
//           )}
//           {adminLaboratoryAuth === false ? (
//             <Route path="/lab/*" name="Lab Home" element={<LaboratoryLogin />} />
//           ) : (
//             <Route path="/lab/*" name="Lab Home" element={<Laboratory />} />
//           )}
//           <Route
//             exact
//             path="/terms-conditions"
//             name="Terms And Conditions Page"
//             element={<TermsAndCondition />}
//           />
//           <Route
//             exact
//             path="/privacy-policy"
//             name="Privacy And Policy Page"
//             element={<PrivacyAndPolicy />}
//           />
//           <Route path="*" name="Home" element={<Main />} />
//           {/* <Route path="/lab/*" name="Lab Home" element={<Laboratory />} /> */}
//         </Routes>
//       </Suspense>
//     </HashRouter>
//   )
// }

// export default App

// update code

/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUserLogin } from './admin/redux/auth/slice'
import { fetchUser } from './main/redux/auth/slice'
import { fetchPharmacyUserLogin } from './pharmacy/redux/auth/slice'
import { fetchLaboratoryUserLogin } from './laboratory/redux/auth/slice'
import { fetchScanCenterUserLogin } from './scanCenter/redux/auth/slice'
import '../src/index.css'
import { persistVisitType } from './admin/redux/settings/slice'
import { getAppointmentStatus, getSlotType } from './admin/redux/providerManagement/slice'

// Pages
const AdminLogin = React.lazy(() => import('./admin/views/pages/login/Login'))
const PharmacyLogin = React.lazy(() => import('./pharmacy/views/pages/login/Login'))
const LaboratoryLogin = React.lazy(() => import('./laboratory//views/pages/login/Login'))
const ScanCenterLogin = React.lazy(() => import('./scanCenter/views/pages/login/Login'))
const TermsAndCondition = React.lazy(() =>
  import('./global/views/pages/termsCondition/TermsCondition'),
)
const PrivacyAndPolicy = React.lazy(() =>
  import('./global/views/pages/privacyPolicy/PrivacyPolicy'),
)

const Admin = React.lazy(() => import('./admin'))
const Main = React.lazy(() => import('./main'))
const Pharmacy = React.lazy(() => import('./pharmacy'))
const Laboratory = React.lazy(() => import('./laboratory'))
const ScanCenter = React.lazy(() => import('./scanCenter'))

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const App = () => {
  const dispatch = useDispatch()
  const { adminAuth } = useSelector((state) => state.adminAuthReducer)
  const { adminPharmacyAuth } = useSelector((state) => state.pharmacyAuthReducer)
  const { adminLaboratoryAuth } = useSelector((state) => state.laboratoryAuthReducer)
  const { adminScanCenterAuth } = useSelector((state) => state.scanCenterAuthReducer)

  useEffect(() => {
    dispatch(fetchUserLogin())
    dispatch(fetchUser())
    dispatch(persistVisitType())
    dispatch(getAppointmentStatus())
    dispatch(fetchLaboratoryUserLogin())
    dispatch(fetchScanCenterUserLogin())
    dispatch(fetchPharmacyUserLogin())
    dispatch(getSlotType())
  }, [])

  return (
    <Router>
      <Suspense fallback={loading}>
        <Routes>
          {adminAuth === false ? (
            <Route exact path="/admin/*" name="Admin Login" element={<AdminLogin />} />
          ) : (
            <Route exact path="/admin/*" name="Home" element={<Admin />} />
          )}
          {adminPharmacyAuth === false ? (
            <Route exact path="/pharmacy/*" name="Admin Login" element={<PharmacyLogin />} />
          ) : (
            <Route exact path="/pharmacy/*" name="Home" element={<Pharmacy />} />
          )}
          {adminLaboratoryAuth === false ? (
            <Route path="/lab/*" name="Lab Home" element={<LaboratoryLogin />} />
          ) : (
            <Route path="/lab/*" name="Lab Home" element={<Laboratory />} />
          )}
          {adminScanCenterAuth === false ? (
            <Route path="/scan-center/*" name="Scan Home" element={<ScanCenterLogin />} />
          ) : (
            <Route path="/scan-center/*" name="Scan Home" element={<ScanCenter />} />
          )}
          <Route
            exact
            path="/terms-conditions"
            name="Terms And Conditions Page"
            element={<TermsAndCondition />}
          />
          <Route
            exact
            path="/privacy-policy"
            name="Privacy And Policy Page"
            element={<PrivacyAndPolicy />}
          />
          <Route path="*" name="Home" element={<Main />} />
        </Routes>
      </Suspense>
    </Router>
  )
}

export default App
